import axios from 'axios';
import { wrapAxios } from '../../axios';
import { IAccountDeletionPreview, IAdminDeleteAccountRequest, IDeleteAccountRequest, IEditUserProfileRequest, ISubscription, IUser } from '@cuspar/ywt.ch.model';
import Stripe from 'stripe';

export const authAPI = {
  authenticate: async () => {
    return wrapAxios(() => axios.post<IUser>(`/auth/authenticate`), false);
  },

  authCallback: async (token: string, locale?: string) => {
    return wrapAxios(() => axios.post(`/auth/callback`, { id_token: token, locale }), false);
  },

  provisionUser: async (token: string, locale?: string) => {
    return wrapAxios<{ provisioned: true }>(() => axios.post(`/auth/provision`, { id_token: token, locale }), false);
  },

  editUserProfile: async (body: IEditUserProfileRequest) => {
    return wrapAxios(() => axios.put<IUser>(`/users/me`, body));
  },
  getAccountDeletionPreview: async () => {
    return wrapAxios(() => axios.get<IAccountDeletionPreview>(`/users/me/deletion-preview`));
  },
  deleteAccount: async (body: IDeleteAccountRequest) => {
    return wrapAxios(() => axios.post(`/users/me/delete`, body));
  },
  getUserDeletionPreview: async (userId: string) => {
    return wrapAxios(() => axios.get<IAccountDeletionPreview>(`/users/${encodeURIComponent(userId)}/deletion-preview`));
  },
  deleteUserAccount: async (userId: string, body: IAdminDeleteAccountRequest) => {
    return wrapAxios(() => axios.post(`/users/${encodeURIComponent(userId)}/delete`, body));
  },
  signout: async () => {
    return wrapAxios(() => axios.get(`/auth/signout`));
  },
  impersonate: async (userId: string) => {
    return wrapAxios(() => axios.post(`/auth/impersonate/${encodeURIComponent(userId)}`));
  },
  exitImpersonation: async () => {
    return wrapAxios(() => axios.post(`/auth/impersonate/exit`));
  },
  getPaymentMethods: async () => {
    return wrapAxios(() => axios.get<{ defaultPaymentMethodId: string | null; paymentMethods: Stripe.PaymentMethod[] }>(`/users/me/payment-methods`));
  },
  setDefaultPaymentMethod: async (paymentMethodId: string) => {
    return wrapAxios(() => axios.put(`/users/me/payment-methods/default`, { paymentMethodId }));
  },
  deletePaymentMethod: async (paymentMethodId: string) => {
    return wrapAxios(() => axios.delete(`/users/me/payment-methods/${encodeURIComponent(paymentMethodId)}`));
  },
  getActiveSubscriptions: async () => {
    return wrapAxios(() => axios.get<ISubscription[]>(`/subscriptions/active`));
  },
  sendVerificationEmail: async (idToken: string, locale?: string) => {
    return wrapAxios<{ sent: boolean }>(() => axios.post(`/auth/send-verification-email`, { id_token: idToken, locale }), { showError: false, captureServerErrors: false });
  },
  sendPasswordResetEmail: async (email: string, locale?: string) => {
    return wrapAxios(() => axios.post(`/auth/send-password-reset-email`, { email, locale }), false);
  },
};
